import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useQueryClient } from '@tanstack/react-query';
import getAppConfigs from 'modules/appConfig/reducer';
import api from 'modules/queries/api';
import { useOidcSilent } from './silentProvider';

const appConfigs = getAppConfigs();

export function ApiConnector() {
	const queryClient = useQueryClient();
	const { isLoading, user } = useAuth();
	const [isSilentLoading] = useOidcSilent();

	const isExpired = user?.expired;
	const accessToken = user?.access_token;
	const userId = user?.profile?.sub;

	// Invalidate endpoints on user change
	useEffect(() => {
		queryClient.invalidateQueries();
	}, [userId, queryClient]);

	// handle auth changes
	useEffect(() => {
		// Pause sooner
		api.apiPause();

		if (isLoading || isSilentLoading) return undefined;

		if (!isExpired && accessToken) {
			api.apiSetAuthorization(`Bearer ${accessToken}`);
		} else {
			api.apiSetBasicAuthorization(
				appConfigs?.guestAuth.username || '',
				appConfigs?.guestAuth.password || '',
			);
		}

		// debounce to allow for oidc to catchup
		const timer = setTimeout(() => {
			api.apiUnpause();
		}, 1);

		return () => {
			clearTimeout(timer);
		};
	}, [accessToken, isExpired, isLoading, isSilentLoading]);

	return null;
}

export default ApiConnector;
